// An highlighted block
<template>
  <div>
    <el-input :rows="rows" :type="rows > 1 ? 'textarea': ''" size="mini" v-model="value2" :readonly="readonly" :disabled="disabled" >
      <span v-if="!disabled" slot="append" @click="handleClick">
              <el-button slot="append" icon="el-icon-edit"></el-button>
          </span>
    </el-input>
    <l-dialog 
        :title="title" 
        :visible.sync="editingVisible" 
        :height="628" 
        :width="1000" 
        v-el-drag-dialog
        @ok="handleCodeSave" 
        @opened="handleOpenedForm"
        @close="handleCloseForm">
        <l-code-editor-panel 
            ref="editor" 
            :readonly="readonly" 
            :disabled="disabled" 
            v-model="editingCode"
            :mode="mode"
            :CodeDescription="CodeDescription"
            :theme="theme"
            :Hints="Hints"
            :category="category"
            :method="method"
            :params="params"
            >
        </l-code-editor-panel>
    </l-dialog>
  </div>
</template>
<script>

//{required: true, message: this.$t('车号是必填项')},
//{validator: this.validateCarNum, message: '车牌号格式不正确'}
export default {
  description: '代码编辑',
  name: 'l-code-editor-input',
  props: {
    value: {},
    rows:{
        type: Number,
        default: 1
    },
    readonly: Boolean,
    disabled: Boolean,
    title: {
            type:String,
            default: '代码编辑'
        }, 
    category:{
            type:String,
            default: 'formEvent'
        },
    method:{
            type:String,
            default: 'CallFunction'
        },
    params:{
            type:String,
            default: ''
        }, 
        mode: {
            type:String,
            default: 'text/x-csharp'
        },
        CodeDescription:{
            type: String,
            default: ''
        },
        Hints: {
            type: Array,
            default: () => []
        },
        theme:{
            type:String,
            default: 'erlang-dark'
        },
  },
  data() {
    return {
        editingVisible: false,
        editingCode: '',
    }
  },
  computed:{
    value2:{
        get(){
            return this.value;
        },
        set(val){
            this.$emit('input', val)
            this.$emit('change', val)
        }
    }
  },
  methods: {
    handleClick(){
        this.editingVisible = true;
    },
    handleOpenedForm() {
        this.editingCode = this.value2        
    },
    handleCloseForm(){
    },
    handleCodeSave(){
        this.$refs.editor.validate( res=>{
            if(res){
                this.value2 = this.editingCode
                this.editingVisible = false;
            }
        })
    }
  }
}
</script>

